export type DeadlineResult<T> =
  | { readonly status: 'settled'; readonly value: T }
  | { readonly status: 'failed' }
  | { readonly status: 'cancelled' }
  | { readonly status: 'timed-out' };

/** Bound optional boot work and detach its timer when the provider unmounts. */
export async function settleByDeadline<T>(
  operation: Promise<T>,
  timeoutMs: number,
  signal: AbortSignal,
): Promise<DeadlineResult<T>> {
  return await new Promise((resolve) => {
    if (signal.aborted) {
      resolve({ status: 'cancelled' });
      return;
    }
    let settled = false;
    const onAbort = () => finish({ status: 'cancelled' });
    const finish = (result: DeadlineResult<T>) => {
      if (settled) {
        return;
      }
      settled = true;
      globalThis.clearTimeout(timeoutId);
      signal.removeEventListener('abort', onAbort);
      resolve(result);
    };
    signal.addEventListener('abort', onAbort, { once: true });
    const timeoutId = globalThis.setTimeout(() => finish({ status: 'timed-out' }), timeoutMs);
    operation.then(
      (value) => finish({ status: 'settled', value }),
      () => finish({ status: 'failed' }),
    );
  });
}
